export default __webpack_public_path__ + "static/char-s-31-ja-abce6950adbd5e311b16828013601f18.webp";